import cn from 'classnames';
import { ReactNode } from 'react';

import './card.scss';

type CardHeaderProps = {
  children: ReactNode;
  variant?: 'default' | 'success' | 'lightpink' | 'lightgreen' | 'darkblue';
  spacingY?: 'small' | 'large';
};

export function CardHeader({
  children,
  variant = 'default',
  spacingY = 'small',
}: CardHeaderProps) {
  return (
    <div
      className={cn(
        'card-internal__header w-full flex__jc--center p-x-l  border-solid border-bottom-s',
        spacingY === 'large' ? 'p-y-l' : 'p-y-s',
        {
          'bg-gray-50 border-color-gray-500': variant === 'default',
          'bg-green-500 color-white border-color-green-500': variant === 'success',
          'bg-lightpink color-white border-color-gray-500': variant === 'lightpink',
          'bg-lightgreen color-white border-color-gray-500': variant === 'lightgreen',
          'bg-blue-800 color-white border-color-gray-500': variant === 'darkblue',
        },
      )}
    >
      {children}
    </div>
  );
}
